import { render, staticRenderFns } from "./PaymentReceiveEmail.vue?vue&type=template&id=1df68490&scoped=true&"
import script from "./PaymentReceiveEmail.vue?vue&type=script&lang=js&"
export * from "./PaymentReceiveEmail.vue?vue&type=script&lang=js&"
import style0 from "./PaymentReceiveEmail.vue?vue&type=style&index=0&id=1df68490&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df68490",
  null
  
)

export default component.exports